/* External */
import {
  memo, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

/* Components */
import LanderPage from '../../../components/LanderPage';

/* Providers */
import { useGtmLocalContext } from '../../../providers/GtmLocalProvider';

/* Utils */
import { useCountry } from '../../../providers/ConfigProvider';
import {
  formatPlaySource,
  GTM_CATEGORIES,
  GTM_EVENT_NAMES,
  GTM_SUBCATEGORIES,
} from '../../../utils/googleTags';

/* Styles */
import './Lander.scss';

function Lander({ sourceProvider = '', children }) {
  const { state: locationState } = useLocation();
  const { pageId } = useParams();
  const { commonTaggingEvent } = useGtmLocalContext();
  const tagsMountRef = useRef(true);
  const country = useCountry();

  useEffect(() => {
    if (tagsMountRef.current && country && pageId && locationState) {
      commonTaggingEvent({
        category: GTM_CATEGORIES.NETWORK_AND_COLLECTION_PAGE_DATA,
        subCategory: GTM_SUBCATEGORIES.PAGES.NETWORK_PAGE,
        eventName: GTM_EVENT_NAMES.PAGE_VIEW,
        data: {
          providerName: pageId,
          content: {
            playSource: formatPlaySource({
              parentLander: locationState?.parentLander,
              section: locationState?.carouselTitle,
              provider: locationState?.providerName,
            }) || locationState?.gtmPlaySource,
          },
        },
      });
      tagsMountRef.current = false;
    }
  }, [
    commonTaggingEvent,
    country,
    locationState,
    locationState?.carouselTitle,
    locationState?.gtmPlaySource,
    locationState?.parentLander,
    locationState?.providerName,
    pageId,
  ]);

  return (
    <LanderPage
      pageId={pageId}
      sourceProvider={sourceProvider}
    >
      {children}
    </LanderPage>
  );
}

Lander.propTypes = {
  sourceProvider: PropTypes.string,
  children: PropTypes.node,
};

export default memo(Lander);
